export default __webpack_public_path__ + "static/media/download_record.555907fa.svg";